import { forwardRef, useImperativeHandle, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { IonIcon, IonPopover } from '@ionic/react'
import { alertCircleOutline } from 'ionicons/icons'

import { appConfig } from '@/services/config'

export interface WarningAlertRef {
  open: () => void
}

const WarningAlert = forwardRef((_, ref) => {
  const { t } = useTranslation('common')
  const [isOpen, setIsOpen] = useState(false)

  useImperativeHandle<unknown, WarningAlertRef>(ref, () => ({
    open() {
      setIsOpen(true)
    },
  }))

  const handleDismiss = () => setIsOpen(false)

  return (
    <IonPopover
      isOpen={isOpen}
      onDidDismiss={handleDismiss}
      className="warning-popover"
      showBackdrop
      backdropDismiss={false}
    >
      <div
        className="flex flex-col items-center px-3 py-4 text-center"
        data-test="popover"
      >
        <IonIcon
          icon={alertCircleOutline}
          color="danger"
          className="text-5xl mb-3"
        />
        <h3 className="mb-5">{t('withdraw.warningTitle')}</h3>
        <span>
          <Trans>
            {t('withdraw.warningDescriptionAlert', {
              currency: appConfig.currency,
            })}
          </Trans>
        </span>
      </div>
      <div className="flex border-t" data-test="popover-reply">
        <button className="w-full p-3" onClick={handleDismiss}>
          {t('withdraw.warningAcknowledgeAlert')}
        </button>
      </div>
    </IonPopover>
  )
})

// Explicitly defining a display name for the component
WarningAlert.displayName = 'WarningAlert'

export default WarningAlert
